import { createSlice } from '@reduxjs/toolkit'

export const LandmarksSlice = createSlice({
  name: 'landmarks',
  initialState: {value: []},
  reducers: {
    setLandmarksDataReducer: (state, action) => {
      state.value = action.payload
    },
    addLandmarks: (state, action) => {
      if(state.value.filter(elm => elm.building_ID === action.payload[0].building_ID).length > 0) return
      state.value = state.value.concat(action.payload)
    }
  }
})

export default LandmarksSlice.reducer
export const { setLandmarksDataReducer, addLandmarks } = LandmarksSlice.actions